import { Dropdown, IDropdownOption } from '@fluentui/react';

import { actions, useFormSelector } from '../../../slice';
import { FormVariables } from '../../../slice/newFormReducers';

export default () => {
  const value = useFormSelector(selector);

  return (
    <Dropdown
      label="Seri"
      options={options}
      selectedKey={value || "A"}
      onChange={onChange}
    />
  );
};

const selector = (state: FormVariables) => state.serial;
const onChange = (_?: any, newValue?: IDropdownOption<any>) =>
  actions.setFormVariable(["serial", newValue?.key]);
const options: IDropdownOption[] = [
  { key: "A", text: "A" },
  { key: "Y", text: "Y" },
  { key: "K", text: "K" },
];
